import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import CustomerSSidebar from "./CustomerSSidebar";
import Header from "../../../component/Header";

const apiUrl = process.env.REACT_APP_API_URL;

function ESummary() {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState(null);
  const [data, setData] = useState([]);
  const [dataScreen, setDataScreen] = useState([]);
  const [rateDaily, setRateDaily] = useState(0);
  const [profit, setProfit] = useState(4500);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${apiUrl}/sortedItems`);
      const responseRate = await axios.get(`${apiUrl}/dailyRate`);
      const fetchedData = response.data.map((item) => ({
        model: item.Model.trim().toLowerCase(),
        storage: item.Storage.trim(),
        sim: item.Sim.trim().toLowerCase(),
        com1: Number(item.com1 || 70),
        com2: Number(item.com2 || 40),
        deliveryFee: Number(item.DeliveryFee || 10),
        price: Number(item.Price),
      }));

      const grouped = new Map();

      fetchedData.forEach((item) => {
        const key = `${item.model}-${item.storage}-${item.sim}`;
        const existing = grouped.get(key);

        if (!existing) {
          grouped.set(key, { ...item, count: 1 });
        } else {
          // Increment count
          existing.count += 1;

          // Keep item with the higher price
          if (item.price > existing.price) {
            existing.price = item.price;
          }

          grouped.set(key, existing);
        }
      });

      const filteredData = Array.from(grouped.values()).sort((a, b) =>
        a.model.localeCompare(b.model)
      );
      setRateDaily(
        responseRate.data.length > 0 ? responseRate.data[0].rate : 0
      );

      setData(filteredData);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setErrors(error.response?.data?.message || "An error occurred");
    }
  };

  const fetchDataScreen = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${apiUrl}/sortedItemscreen`);
      const fetchedData = response.data.map((item) => ({
        model: item.ItemName.trim().toLowerCase(),
        price: Number(item.price),
      }));
      console.log("fetchedData", fetchedData);
      const grouped = new Map();
      console.log("grouped", grouped);

      fetchedData.forEach((item) => {
        const key = `${item.model}`;
        console.log("key", key);
        const existing = grouped.get(key);

        if (!existing) {
          grouped.set(key, { ...item, count: 1 });
        } else {
          // Increment count
          existing.count += 1;

          // Keep item with the higher price
          if (item.price > existing.price) {
            existing.price = item.price;
          }

          grouped.set(key, existing);
        }
      });

      const filteredData = Array.from(grouped.values()).sort((a, b) =>
        a.model.localeCompare(b.model)
      );
      setDataScreen(filteredData);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setErrors(error.response?.data?.message || "An error occurred");
    }
  };

  const fetchOtherItems = async () => {
    try {
      const response = await axios.get(`${apiUrl}/otherItems`);
      const grouped = {};

      response.data.forEach((item) => {
        const key = `${item.Model}-${item.deliveryFee}-${item.carrier}-${item.price}`;
        if (!grouped[key]) {
          grouped[key] = { ...item, count: 1 };
        } else {
          grouped[key].count++;
        }
      });
    } catch (err) {
      setErrors("Failed to load other items.");
    }
  };

  const totalPrice = () => {
    let sum = 0;

    data.forEach((item) => {
      const price = Number(item.Price) || 0;
      const com1 = Number(item.com1) || 0;
      const com2 = Number(item.com2) || 0;
      const deliveryFee = Number(item.DeliveryFee) || 0;
      sum = price + com1 + com2 + deliveryFee;
    });

    return sum;
  };

  useEffect(() => {
    fetchData();
    fetchOtherItems();
    fetchDataScreen();
    totalPrice();
  }, []);

  return (
    <>
      <Header/>
      <CustomerSSidebar />
      <div className="items-center flex flex-col justify-center mt-5 overflow-auto">
        <div className="border-1 border-slate-200 mt-20 w-3/4 mb-20 px-5 rounded-md overflow-auto justify-center align-middle">
          <table className="border-collapse table-auto w-full mb-10 overflow-x-scroll">
            <thead>
              <tr>
                <th className="border-b-1 pb-3 border-slate-600 text-left">
                  Model
                </th>
                <th className="border-b-1 pb-3 border-slate-600 text-left">
                  Storage
                </th>
                <th className="border-b-1 pb-3 border-slate-600 text-left">
                  Sim
                </th>
                <th className="border-b-1 pb-3 border-slate-600 text-left">
                  Price
                </th>
                <th className="border-b-1 pb-3 border-slate-600 text-left">
                  Sold
                </th>
                <th className="border-b-1 pb-3 border-slate-600 text-left">
                  Count
                </th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => {
                return (
                  <tr key={index}>
                    <td className="border-b-1 pb-3 border-slate-600 text-left">
                      {item.model}
                    </td>
                    <td className="border-b-1 pb-3 border-slate-600 text-left">
                      {item.storage}
                    </td>
                    <td className="border-b-1 pb-3 border-slate-600 text-left">
                      {item.sim}
                    </td>
                    <td className="border-b-1 pb-3 border-slate-600 text-left">
                      {item.price}
                    </td>
                    <td className="border-b-1 pb-3 border-slate-600 text-left">
                      {Math.ceil(
                        ((item.price +
                          item.com1 +
                          item.com2 +
                          item.deliveryFee) *
                          rateDaily +
                          2000 +
                          profit) /
                          500
                      ) * 500}
                    </td>

                    <td className="border-b-1 pb-3 border-slate-600 text-left">
                      {item.count}
                    </td>
                  </tr>
                );
              })}
              <tr>
                <td className="border-t-2 pt-3 font-bold border-slate-600 text-left">
                  Total
                </td>
                <td className="border-t-2 pt-3 font-bold border-slate-600 text-left">
                  {data.reduce((total, item) => total + item.count, 0)}
                </td>
              </tr>
            </tbody>
          </table>
          <h2 className="font-bold text-xl">Screen Models</h2>
          <table className="border-collapse table-auto w-full mb-10 overflow-x-scroll">
            <thead>
              <tr>
                <th className="border-b-1 pb-3 border-slate-600 text-left">
                  ItemName
                </th>
                <th className="border-b-1 pb-3 border-slate-600 text-left">
                  Price
                </th>
                <th className="border-b-1 pb-3 border-slate-600 text-left">
                  Sold
                </th>
                <th className="border-b-1 pb-3 border-slate-600 text-left">
                  Count
                </th>
              </tr>
            </thead>
            <tbody>
              {dataScreen.map((item, index) => {
                return (
                  <tr key={index}>
                    <td className="border-b-1 pb-3 border-slate-600 text-left">
                      {item.model}
                    </td>
                    <td className="border-b-1 pb-3 border-slate-600 text-left">
                      {item.price}
                    </td>
                    <td className="border-b-1 pb-3 border-slate-600 text-left">
                      {Math.ceil(
                        ((item.price + 30) * rateDaily + 1000 + profit) / 500
                      ) * 500}
                    </td>
                    <td className="border-b-1 pb-3 border-slate-600 text-left">
                      {item.count}
                    </td>
                  </tr>
                );
              })}
              <tr>
                <td className="border-t-2 pt-3 font-bold border-slate-600 text-left">
                  Total
                </td>
                <td className="border-t-2 pt-3 font-bold border-slate-600 text-left">
                  {dataScreen.reduce((total, item) => total + item.count, 0)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default ESummary;
